import type { DetrixSession } from '../types';
import type { TabId } from '../store/tabId';

function truncate(s: string, max: number): string {
  if (s.length <= max) return s;
  return `${s.slice(0, max - 1)}…`;
}

/** One-line preview for the inspection panel (collapsed bar / tooltips). */
export function selectionSummary(session: DetrixSession, activeTab: TabId, selectedId: string | null): string {
  if (!selectedId) return 'Inspection';
  switch (activeTab) {
    case 'steps': {
      const s = session.steps?.find((x) => x.id === selectedId);
      return s ? truncate(s.title, 52) : 'Step';
    }
    case 'actions': {
      const a = session.actions?.find((x) => x.id === selectedId);
      return a ? truncate(a.summary, 52) : 'Action';
    }
    case 'network': {
      const n = session.network.find((x) => x.id === selectedId);
      if (n) {
        const st = n.response?.status ?? 0;
        return `${n.request.method} ${truncate(n.request.url, 40)} · ${st || '—'}`;
      }
      const r = session.browserResources?.find((x) => x.id === selectedId);
      return r ? `${r.resourceType} ${truncate(r.url, 44)}` : 'Network';
    }
    case 'events': {
      const e = session.events.find((x) => x.id === selectedId);
      return e ? truncate(e.type, 48) : 'Event';
    }
    default:
      return 'Inspection';
  }
}
